// Unified runtime configuration accessor.
// Centralizes precedence + validation for environment dependent values.
// Precedence pattern for each value:
// 1. window.__RUNTIME_CONFIG__ (runtime injected, mutable per deployment)
// 2. Legacy dedicated globals (e.g. window.__STRIPE_PUBLISHABLE_KEY__) if any
// 3. Build-time process.env (CRA)
// 4. Fallback constant (only for non-secret dev defaults)

const g = (typeof window !== 'undefined') ? window : undefined;
const RC = (g && g.__RUNTIME_CONFIG__) || {};

// Generic safe getter
export function getRuntimeValue(key, { legacyGlobal, envVar, fallback, transform, validate } = {}) {
  let raw = RC[key];
  if (raw == null && legacyGlobal && g) raw = g[legacyGlobal];
  if (raw == null && envVar) raw = process.env[envVar];
  if (raw == null) raw = fallback;
  if (transform) {
    try { raw = transform(raw); } catch { /* swallow transform errors */ }
  }
  if (validate && !validate(raw)) return undefined;
  return raw;
}

// Normalizers / validators
const normalizeUrl = (u) => (u || '').replace(/\/+$/, '');
const isRealStripeKey = (k) => typeof k === 'string' && k.length > 15 && /^pk_(test|live)_/.test(k) && !/pk_test_(PLACEHOLDER|12345)/.test(k);

// DATA SERVICE BASE URL
export const DATA_SERVICE_BASE_URL = normalizeUrl(
  getRuntimeValue('REACT_APP_DATA_SERVICE_BASE_URL', {
    envVar: 'REACT_APP_DATA_SERVICE_BASE_URL',
    fallback: 'https://hibernate-service-491484225296.us-central1.run.app'
  })
);

// STRIPE PUBLISHABLE KEY
export const STRIPE_PUBLISHABLE_KEY = getRuntimeValue('STRIPE_PUBLISHABLE_KEY', {
  legacyGlobal: '__STRIPE_PUBLISHABLE_KEY__',
  envVar: 'REACT_APP_STRIPE_PUBLISHABLE_KEY',
  validate: isRealStripeKey
}) || null;

export const STRIPE_ENABLED = Boolean(STRIPE_PUBLISHABLE_KEY);

export function ensureStripeEnabled() {
  if (!STRIPE_ENABLED) throw new Error('Stripe not enabled (missing or invalid publishable key).');
  return STRIPE_PUBLISHABLE_KEY;
}

// CORPORATE EMAIL
export const CORPORATE_EMAIL = getRuntimeValue('CORPORATE_EMAIL', {
  envVar: 'REACT_APP_CORPORATE_EMAIL',
  fallback: 'corporate@docuhounds.com'
});

// Diagnostics (dev only)
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line no-console
  console.log('[RuntimeConfig] BASE_URL=', DATA_SERVICE_BASE_URL, 'STRIPE_ENABLED=', STRIPE_ENABLED);
}
